module.exports = __webpack_public_path__ + "img/symbol_5.bb9c3446.png";